<app-loader *ngIf="loading" position="absolute"></app-loader>
<form [formGroup]="showcaseForm">
  <label for="code">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.code'|translate}}*
  </label>
  <mat-form-field>
    <input id="code" matInput type="text" formControlName="code"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.code'|translate" autocomplete="off">
  </mat-form-field>
  <label for="area">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.area'|translate}}*
  </label>
  <mat-form-field>
    <input id="area" matInput type="text" formControlName="area"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.area'|translate" autocomplete="off">
  </mat-form-field>
  <label for="description">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.description'|translate}}*
  </label>
  <mat-form-field>
    <input id="description" matInput type="text" formControlName="description"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.description'|translate" autocomplete="off">
  </mat-form-field>
  <label for="code">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.floorCode'|translate}}*
  </label>
  <mat-form-field>
    <mat-select id="floorCode" formControlName="floorCode"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.floorCode'|translate" autocomplete="off">
      <mat-option *ngFor="let floor of floors" [value]="floor.code">
        <p class="text-value"> {{floor.description}} </p>
      </mat-option>
    </mat-select>
  </mat-form-field>
  <label for="order">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.order'|translate}}*
  </label>
  <mat-form-field>
    <input id="order" matInput type="number" formControlName="order"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.order'|translate" autocomplete="off">
  </mat-form-field>
  <label for="securityDeviceId">
    {{'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.securityDeviceId'|translate}}
  </label>
  <mat-form-field>
    <input id="securityDeviceId" matInput type="text" formControlName="securityDeviceId"
      [placeholder]="'PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.PLACEHOLDERS.securityDeviceId'|translate"
      autocomplete="off">
  </mat-form-field>
</form>
<div class="footer">
  <app-bulgari-button (click)="createShowcase()" [type]="'black'" [customStyle]="{width: '100%', height:'3.5em'}"
    [text]="('PAGES.ALLOCATION.CREATE_SHOWCASE_DIALOG.CONFIRM' | translate) | uppercase"></app-bulgari-button>
</div>
